// Backs the product-card -> product-detail shared-element image morph.
// Only the clicked card's image may carry a viewTransitionName at the
// moment of navigation — the spec for this is explicit: duplicate names on
// simultaneously-visible elements throw and the browser skips the
// transition entirely. So no card carries a name by default; the clicked
// one sets one (via a ref mutation in its onClick, before navigating —
// see ProductCard.jsx), and records which product id that was here. The
// destination page reads it once (read-and-clear) to decide whether to
// apply the matching name to its hero image.
let pendingMorphId = null;

export function setMorphCandidate(id) {
  pendingMorphId = id;
}

export function consumeMorphCandidate() {
  const id = pendingMorphId;
  pendingMorphId = null;
  return id;
}

export const morphNameFor = (id) => `product-${id}`;
